import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import uuid from 'uuid';
import Radio from '@material-ui/core/Radio';
import colors from 'theme/colors';

const { fontBody } = colors;

const RadioButton = withStyles({
  root: {
    '&.Mui-checked': {
      color: `${fontBody}`,
    },
  },
})(Radio);

export interface RadioButtonsGroupInterface {
  handleChange: Function;
  id?: number | string;
  options: { name: string; selected: boolean }[];
}

export default function RadioButtonsGroup({ options, handleChange, id }: RadioButtonsGroupInterface) {
  return (
    <>
      {options?.map((option: { name: string; selected: boolean }) => (
        <div key={uuid()}>
          <RadioButton
            key={uuid()}
            name={option.name}
            value={option.name}
            checked={!!option.selected}
            onChange={event => handleChange(id, event)}
          />
          <label htmlFor="radio_btn">{option.name}</label>
        </div>
      ))}
    </>
  );
}
